<template>
  <!-- weatherStation -->
  <div class="guangfu-tongyi">
    <div class="con">

      <div class="my-list">
        <div class="list-item top-item left-item">
          <div class="img-left">
            <img src="../../assets/unifyImg/qixiang.png" alt="">
          </div>
          <div class="ceshi">
            <div class="item-top">

              <div class="right-name">
                <div class="names">
                  <p>气象站({{dataList.stationName}})</p>
                </div>
                <div>型号：{{dataList.deviceSpecification}}</div>

              </div>
            </div>
            <div class="canshu">
              <div class="canshu-left">
                <div class="names">
                  <span>运行参数</span>

                </div>

              </div>
              <div class="canshu-bo">
                <div class="ele-left">
                  <div class="canshu-item">
                    <span>在线状态</span>
                    <span v-if="dataList.runningStatus == 1" class="mynormal">正常</span>
                    <span v-else class="abnormal">异常</span>
                  </div>
                  <div class="canshu-item">
                    <span>瞬时辐照</span>
                    <span>1W/m²</span>
                  </div>

                  <div class="canshu-item">
                    <span>环境温度</span>
                    <span>30°C</span>
                  </div>
                  <div class="canshu-item">
                    <span>环境湿度</span>
                    <span>21%</span>
                  </div>
                </div>
                <div class="ele-right">
                  <div class="canshu-item">
                    <span>瞬时风向</span>
                    <span>东北风</span>
                  </div>
                  <div class="canshu-item">
                    <span>瞬时风速</span>
                    <span>21 m/s</span>
                  </div>
                  <div class="canshu-item">
                    <span>大气压值</span>
                    <span>12hPa</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="list-item top-item right-item" style="margin-left:12px">
          <div id="middle3" style="width:100%;height:330px"></div>
        </div>
        <div class="list-item list-item-s" style="margin-top:15px">
          <div id="middle4" style="width:100%;height:100%"></div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
  import {meteorologicalFindDataByUnitId} from "../../api/gfSystem";
  let middle3,middle4
  export default {
    name: 'WedoWebInverter',

    data () {
      return {
        nowCheck: 0,
        option1: {
          title: [
            {
              text: '日辐照度趋势'
            }
          ],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: ['1时','2时','3时','4时','5时','6时','7时','8时','9时'],
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          legend: {
            data: ["瞬时辐照度","辐射日累计"],
            top: 10,
            icon: "circle", //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 10, // 设置宽度
            itemHeight: 10, // 设置高度
            itemGap: 30, // 设置间距
          },
          series: [
            {
              name: '瞬时辐照度',
              type: 'line',
              itemStyle: {
                color: '#2278f8'
              },
              data: [12,12,3,4,5,6,45,74,45,23,32,12,12,3,4,5,6,45,74,45,23,32]
            },

            {
              name: '辐射日累计',
              type: 'line',
              itemStyle: {
                color: '#86dc6b'
              },
              data: [22,22,53,6,75,16,115,94,55,43,42,22,22,53,6,75,16,115,94,55,43,42]
            }
          ]
        },
        option2: {
          title: [
            {
              text: '月平均辐射量统计'
            }
          ],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: ['1号','2号','3号','4号','5号','6号','7号','8号','9号'],
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          legend: {
            data: ["日平均值"],
            top: 10,
            icon: "circle", //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 10, // 设置宽度
            itemHeight: 10, // 设置高度
            itemGap: 30, // 设置间距
          },
          series: [
            {
              name: '日平均值',
              type: 'bar',
              itemStyle: {
                color: '#2278f8'
              },
              barWidth: '30',
              data: [12,12,3,4,5,6,45,74,345,23,32,234,45,6,56,456,456,]
            },
          ]
        },
        dataList: {}

      };
    },
    //过滤器
    filters: {

      //消缺等级
      priorityfun (val) {
        if(val=='0') {
          return "北风"
        } else if(val=='45') {
          return "东北风"
        } else if(val=='90') {
          return "东风"
        } else if(val=='135') {
          return "东南风"
        } else if(val=='180') {
          return "南风"
        } else if(val=='225') {
          return "西南风"
        } else if(val=='270') {
          return "西风"
        } else if(val=='315') {
          return "西北风"
        } else {
          return val
        }
      },
    },
    computed: {
      unitId () {
        return this.$store.unitStore.state.nowUnit
      }
    },
    watch: {
      //侦听单位变化
      unitId () {
        this.getData()
      },


    },
    mounted () {
      var timerArr=[]
      for(let i=0;i<24;i++) {
        timerArr.push(i+'时')
      }

      // 创建一个表示当前日期的Date对象
      var currentDate=new Date();

      // 获取当前月份
      var currentMonth=currentDate.getMonth();
      // 获取下一个月的第一天
      var nextMonthFirstDay=new Date(currentDate.getFullYear(),currentMonth+1,1);
      // 获取当前月份的最后一天
      var currentMonthLastDay=new Date(nextMonthFirstDay.getTime()-1);
      // 获取当前月份的天数
      var daysInCurrentMonth=currentMonthLastDay.getDate();
      var dateArr=[]
      for(let i=1;i<=daysInCurrentMonth;i++) {
        dateArr.push(i+'号')
      }
      this.option1.xAxis[0].data=timerArr
      this.option2.xAxis[0].data=dateArr
      this.init()
      this.getData()
    },

    methods: {
      init () {
        // 饼图
        //中间柱状图
        middle3=echarts.init(document.getElementById("middle3"));
        middle3.setOption(this.option1,true);
        middle3.resize();

        middle4=echarts.init(document.getElementById("middle4"));
        middle4.setOption(this.option2,true);
        middle4.resize();


      },
      //获取数据
      getData () {
        var d={
          'unitId': this.unitId.id
        }
        meteorologicalFindDataByUnitId(d).then(res => {
          console.log("获取数据",res);
          this.dataList=res.data[0]
          this.tranChartFn()
        })
      },
      //处理图表数据
      tranChartFn () {
        this.option1.series[0].data=this.dataList.dayTendency.tendency
        this.option1.series[1].data=this.dataList.dayTendency.accumulated
        middle3.setOption(this.option1,true);
        this.option2.series[0].data=this.dataList.monTendency
        middle4.setOption(this.option2,true);
      }
    },
  };
</script>

<style lang="scss" scoped>
  .tab-top {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    height: 42px;
    border-bottom: 2px solid #e6e6e6;

    .left-p {
      display: flex;
      font-size: 16px;
      color: #666;
      height: 42px;

      p {
        margin-right: 20px;
        margin-top: 5px;

        &.active {
          color: #368ED9;
          border-bottom: 2px solid #368ED9;
        }
      }
    }
  }

  .mynormal {
    color: #0dae88;
  }

  .abnormal {
    color: #ff1d1d;
  }

  .con {
    padding: 0px 12px 12px 12px;
  }

  .my-list {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
  }

  .ceshi {
    width: calc(100% - 230px);
  }

  .list-item {


    background-color: #fff;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    // margin-top: 20px;
    // margin-right: 15px;
    padding: 12px 20px;
    box-sizing: border-box;
    display: flex;

    img {
      width: 200px;
      height: 300px;
      margin-right: 15px;
    }

    .item-top {
      width: 100%;
      height: 50px;


      display: flex;

      img {
        width: 110px;
        height: 120px;
        margin-right: 20px;
      }

      .right-name {
        width: 100%;
        height: 50px;

        .names {
          width: 100%;
          display: flex;
          justify-content: space-between;

          p {
            font-size: 16px;

            span {
              font-size: 14px;
              color: #999999;
            }
          }

        }

        .zhaungtai {
          width: 70px;
          height: 25px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #edf8ec;
          color: #70b66f;
          border-radius: 35px;
        }

        .btns {
          margin-top: 10px;
          width: 100px;
          height: 30px;
          border-radius: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #368ed9;
          border: 1px solid #368ed9;
        }
      }
    }

    .canshu {
      width: 100%;
      margin-top: 50px;
      height: 200px;
      background-color: #f7f8fc;
      border-radius: 4px;
      padding: 20px 12px;
      box-sizing: border-box;

      .canshu-left {
        .names {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .spoan2 {
            font-size: 13px;
            color: #999;
          }
        }
      }

      .canshu-bo {
        width: 100%;
        display: flex;
      }

      .ele-left {
        width: 50%;

      }

      .canshu-item {
        border-right: 1px solid #999;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 15px;
        padding-right: 15px;
        box-sizing: border-box;
        color: #000;
      }

      .ele-right {
        width: 50%;

        .canshu-item {
          padding-left: 15px;
          border: 0px;
        }
      }

    }
  }

  .top-item {
    height: 356px;
  }

  .left-item {
    width: 43%;
  }

  .right-item {
    width: calc(57% - 12px);
  }

  .list-item-s {
    width: 100%;
    height: calc(100% - 374px);
  }
</style>